<template>
  <div class="Notification-fallback">
    <div class="Notification-fallbackGraphic">
      <svg>
        <use xlink:href="#Job" />
      </svg>
    </div>
    <h3>You have no job notifications</h3>
    <p>Recently saved jobs and alerts will appear here.</p>
    <img
      :src="image"
      alt="no jobs"
    >
    <p>Click on the heart icon next to a job to save it. You will be reminded when job deadlines are approaching.</p>
  </div>
</template>
<script>
import HeartSearchHint from '../images/heart-search-hint.png';

export default {
  data() {
    return {
      image: HeartSearchHint,
    };
  },
};
</script>

<style lang="scss">
  .Notification-fallback{
    padding:3rem  1.5rem;
    text-align: center;
    overflow-y: scroll;
  }
  .Notification-fallbackGraphic {
    margin-bottom: 1rem;
    svg {
      width: 60px;
      height: 60px;
      fill: grey;
    }
  }
</style>
